import React from "react";

import { func, string, bool, object } from "prop-types";

import { TextAreaGroup } from "../../../common";
import * as style from "./styles.module.scss";

const Seeking = ({
  positionSeeking,
  onChangeHandler,
  isValid,
  validation = undefined,
}) => (
  <div className="mt-1">
    Type of work*
    <TextAreaGroup
      value={positionSeeking}
      onChange={(e) => {
        onChangeHandler("positionSeeking", e.target.value);
      }}
      classes={`register_field ${style.workForm__desiredPosition}`}
      validationMessages={isValid ? [] : validation.positionSeeking}
      validationMessageIsRed
      dontDisplayErrorMessage
      onlyShowValidationAfterChange
    />
    <div className="text-dark mb-hf">
      <p className="mb-0 mt-1">
        Please list at least 5 job types/roles you are seeking, e.g.:
      </p>
      <ul className="pl-1">
        <li>Warehouse operative, picker, packer, cleaner, general assistant</li>
        <li>
          Administrator, office worker, data entry, receptionist, accounts
          assistant
        </li>
        <li>
          Catering assistant, waiting staff, bar staff, housekeeping, data entry
        </li>
      </ul>
    </div>
  </div>
);

Seeking.propTypes = {
  isValid: bool.isRequired,
  validation: object,
  positionSeeking: string.isRequired,
  onChangeHandler: func.isRequired,
  description: string.isRequired,
};

export default Seeking;
